import {Component, Inject, OnInit, Input} from '@angular/core';


@Component({
    selector: 'data-generator-create-edit-radio-button',
    templateUrl: 'angular-blocworx/components/fields/data-generator/templates/create-edit/radio-button.html',
    styleUrls: ['angular-blocworx/components/fields/data-generator/data-generator.component.scss'],
})

export class DataGeneratorCreateEditRadioButton implements OnInit {

    @Input() fc;
    @Input() scanStation;

    ngOnInit(): void {

    }

    setFieldPopUp(activeField) {
        this.fc.initialFieldParams={};
        this.scanStation.activeField = activeField;
    }
}